export default __webpack_public_path__ + "static/media/testnet_polygon.55ce90cc.svg";